// extracted by mini-css-extract-plugin
export default {"Advanced":"Advanced_Advanced__NkSJb","Labels":"Advanced_Labels__QPxN0"};